import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import router from "next/router";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { Button } from "components/button";
import { Input } from "components/input";
import { SelectInput } from "components/select";
import { useNotify } from "hooks";
import { requestCallBack } from "services/finance";
import { InputWrapper } from "styles/form";
import { RequestFormContainer } from "./hero-section.style";

const RequestCallBack = () => {
   const { notify } = useNotify();
   const [isLoading, setIsLoading] = useState(false);

   const schema = yup.object().shape({
      fullName: yup.string().required("Full name is a required field"),
      phoneNumber: yup
         .string()
         .required("Phone number is a required field")
         .matches(/^[0-9]+$/, "Must be only digits")
         .min(11, "Must be at least 11 digits")
         .max(11, "Must not exceed 11 digits"),
      email: yup.string().email("Please input a valid email").required("Email is required"),
      wardGrade: yup.string().required("Select ward grade is a required field"),
      amountToBorrow: yup.string().required("Amount is a required field"),
      incomePerMonth: yup.string().required("income is a required field"),
   });

   const {
      handleSubmit,
      register,
      control,
      reset,
      formState: { errors, isValid },
   } = useForm({
      resolver: yupResolver(schema),
      mode: "onChange",
   });

   const onSubmit = async (values) => {
      try {
         setIsLoading(true);
         await requestCallBack(values);
         notify({
            message: "Application submitted successful!",
            variant: "success",
         });
         reset();
         router.back();
      } catch (error: any) {
         notify({
            message: error.result.message || error.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsLoading(false);
      }
   };

   const gradeOptions = [
      { label: "Creche", value: "Creche" },
      { label: "Primary school", value: "Primary school" },
      { label: "Secondary school", value: "Secondary school" },
      { label: "Tertiary institution", value: "Tertiary institution" },
   ];

   return (
      <RequestFormContainer>
         <div className="header">
            <h1>Finance Your Child’s Education</h1>
            <p>Let’s help you sort out their tuition.</p>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <InputWrapper className="mt-13">
               <Input
                  label="Full Name"
                  id="fullName"
                  type="text"
                  style={{ height: "5rem" }}
                  {...register("fullName")}
                  error={errors.fullName?.message}
                  defaultValue={""}
                  placeholder="Enter Full Name"
               />
            </InputWrapper>
            <InputWrapper className="mt-13">
               <Input
                  label="Email address"
                  id="email"
                  type="text"
                  style={{ height: "5rem" }}
                  {...register("email")}
                  error={errors.email?.message}
                  defaultValue={""}
                  placeholder="Enter Email"
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-13">
               <Input
                  label="Phone number"
                  id="phoneNumber"
                  type="text"
                  style={{ height: "5rem" }}
                  {...register("phoneNumber")}
                  error={errors.phoneNumber?.message}
                  placeholder="Enter phone number"
               />
               <Controller
                  control={control}
                  name="wardGrade"
                  render={({ field: { onChange } }) => (
                     <SelectInput
                        id="wardGrade"
                        type="text"
                        label="Ward Grade"
                        placeholder="Select grade"
                        onChange={(val: any) => onChange(val.label)}
                        error={errors.wardGrade?.message}
                        options={gradeOptions}
                     />
                  )}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-13">
               <Input
                  label="Amount to borrow"
                  id="amountToBorrow"
                  type="number"
                  style={{ height: "5rem" }}
                  {...register("amountToBorrow")}
                  error={errors.amountToBorrow?.message}
                  placeholder="000 000 000"
               />
               <Input
                  label="Income per month"
                  id="incomePerMonth"
                  type="number"
                  style={{ height: "5rem" }}
                  {...register("incomePerMonth")}
                  error={errors.incomePerMonth?.message}
                  placeholder="000 000 000"
               />
            </InputWrapper>

            <div className="btn-div">
               <Button disabled={!isValid} type="submit" variant="primary" isLoading={isLoading}>
                  Apply for loan
               </Button>
            </div>
         </form>
      </RequestFormContainer>
   );
};

export default RequestCallBack;
